import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, MapPinIcon, ShoppingBagIcon, XIcon } from 'lucide-react';
import { recentPurchases } from '../data/content';
export function FloatingElements() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [index, setIndex] = useState(0);
  const [cta, setCta] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const delay = index === 0 ? 5000 : 8000;
    const showTimer = window.setTimeout(() => setVisible(true), delay);
    const rotateTimer = window.setTimeout(() => {
      setVisible(false);
      setIndex(value => (value + 1) % recentPurchases.length);
    }, delay + 5500);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(rotateTimer);
    };
  }, [dismissed, index]);
  useEffect(() => {
    const onScroll = () => setCta(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const [name, city, plan] = recentPurchases[index];
  return <>
      <AnimatePresence data-id="element-198" data-mp="drhx0ndveqfr">
        {visible && !dismissed && <motion.aside initial={{
        opacity: 0,
        y: 28,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 22,
        scale: 0.96
      }} transition={{
        type: 'spring',
        stiffness: 280,
        damping: 24
      }} className="fixed bottom-4 left-4 z-[60] max-w-[300px] overflow-hidden rounded-2xl border-2 border-gold bg-primary p-3 pr-8 shadow-[0_18px_42px_rgba(234,88,12,.45)]" aria-live="polite" data-id="element-199" data-mp="dtcflv1o66go">
            <div className="absolute inset-y-0 left-0 w-1.5 bg-gold" data-id="element-200" data-mp="11gauwpe1z8d0" />
            <div className="absolute right-0 top-0 h-12 w-12 rounded-bl-full bg-amber-300/30" data-id="element-201" data-mp="15j779yd0288i" />
            <button onClick={() => setDismissed(true)} className="absolute right-1.5 top-1.5 rounded p-1 text-orange-100 transition-colors hover:text-white" aria-label="Cerrar notificación" data-id="element-202" data-mp="1agqwftb8k5f8">
              <XIcon className="h-3.5 w-3.5" data-id="element-203" data-mp="32gyxux6h7nba" />
            </button>
            <div className="flex gap-3" data-id="element-204" data-mp="3gb8ddtwo8zs4">
              <span className="h-fit rounded-full border-2 border-amber-100 bg-gold p-2 text-white shadow-sm" data-id="element-205" data-mp="3gcb4a1tzv281">
                <ShoppingBagIcon className="h-5 w-5" data-id="element-206" data-mp="3q8mgkrtl3s2h" />
              </span>
              <div data-id="element-207" data-mp="3qaqw670uifil">
                <p className="flex items-center gap-1 text-[10px] font-extrabold uppercase tracking-[.12em] text-amber-200" data-id="element-208" data-mp="3l9jlo07bj288">
                  <CheckCircle2Icon className="h-3 w-3" data-id="element-209" data-mp="346n2hx3m0xd" /> Compra reciente
                </p>
                <p className="mt-1 text-xs leading-snug text-orange-50" data-id="element-210" data-mp="3u9pyrkz3u06v">
                  <b className="text-white" data-id="element-211" data-mp="24vbcd7bk6pej">{name}</b> compró el libro digital{' '}
                  <b className="text-amber-200" data-id="element-212" data-mp="24xe1lp4w0ei7">{plan}</b>
                </p>
                <p className="mt-1 flex items-center gap-1 text-[10px] font-medium text-orange-100" data-id="element-213" data-mp="1zxrm191l6m68">
                  <MapPinIcon className="h-3 w-3 text-amber-300" data-id="element-214" data-mp="fepiz2vuwmu3" />
                  {city} · Argentina · hace {index * 6 + 2} min
                </p>
              </div>
            </div>
          </motion.aside>}
      </AnimatePresence>

      <AnimatePresence data-id="element-215" data-mp="anfsy16ebhho">
        {cta && <motion.a href="#pricing" initial={{
        y: 80,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 80,
        opacity: 0
      }} className="fixed bottom-3 left-3 right-3 z-50 rounded-2xl bg-primary py-3.5 text-center font-display text-sm font-bold text-white shadow-lg shadow-primary/30 md:hidden" data-id="element-216" data-mp="am4rw94c4nu9">
            QUIERO MI COMBO ADULTOS MAYORES →
          </motion.a>}
      </AnimatePresence>
    </>;
}